export default __webpack_public_path__ + "static/media/keineTipps.468b921d.png";